import { IExtendedTab } from "components/ExtendedTabs/ExtendedTabs.types";
import { ModelCompareTab } from "../GettingStartedWithUniFi.types";
import {
  AppVariant,
  IHeroSection,
} from "../_components/DesktopHero/DesktopHero.types";

import SwitchingImage from "../assets/tabs/compare/pro-max-48.png";

import LargeDeploymentPoster from "../assets/tour/rack/rack-deployment.jpg";
import LargeDeploymentVideo from "../assets/tour/rack/rack-deployment.mp4";
import LargeDeploymentNetworkVideo from "../../../Sections/GettingStartedWithUniFi/assets/tour/rack/network.mp4";
import LargeDeploymentProtectVideo from "../../../Sections/GettingStartedWithUniFi/assets/tour/rack/protect.mp4";
import LargeDeploymentAccessVideo from "../../../Sections/GettingStartedWithUniFi/assets/tour/rack/access.mp4";
import LargeDeploymentConnectVideo from "../../../Sections/GettingStartedWithUniFi/assets/tour/rack/connect.mp4";

import LargeDeploymentMobilePoster from "../assets/tour/mobile/rack/intro-1080.jpg";
import LargeDeploymentMobileVideo from "../assets/tour/mobile/rack/intro-1080.mp4";
import LargeDeploymentMobileNetworkVideo from "../assets/tour/mobile/rack/network-1080.mp4";
import LargeDeploymentMobileProtectVideo from "../assets/tour/mobile/rack/protect-1080.mp4";
import LargeDeploymentMobileAccessVideo from "../assets/tour/mobile/rack/access-1080.mp4";
import LargeDeploymentMobileConnectVideo from "../assets/tour/mobile/rack/connect-1080.mp4";

export const RACK_DEPLOYMENT_SWITCHING_TAB = {
  id: ModelCompareTab.Switching,
  label: "gettingStartedWithUniFi.compareTabs.switching",
  image: SwitchingImage,
} satisfies IExtendedTab;

export const DEPLOYMENT_HERO_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.simpleDeployment",
  poster: LargeDeploymentPoster,
  src: LargeDeploymentVideo,
  tooltips: [
    {
      left: "15.6%",
      top: "23.1%",
      id: 0,
      variant: AppVariant.Network,
      description: "gettingStartedWithUniFi.hero.tooltips.network",
      video: LargeDeploymentNetworkVideo,
    },
    {
      id: 1,
      left: "15.6%",
      bottom: "28.1%",
      variant: AppVariant.Protect,
      description: "gettingStartedWithUniFi.hero.tooltips.protect",
      video: LargeDeploymentProtectVideo,
    },
    {
      id: 2,
      right: "12.16%",
      top: "23.1%",
      variant: AppVariant.Access,
      description: "gettingStartedWithUniFi.hero.tooltips.access",
      video: LargeDeploymentAccessVideo,
    },
    {
      id: 3,
      right: "12.16%",
      bottom: "28.1%",
      variant: AppVariant.Connect,
      description: "gettingStartedWithUniFi.hero.tooltips.connect",
      video: LargeDeploymentConnectVideo,
    },
  ],
} satisfies IHeroSection;

export const RACK_DEPLOYMENT_MOBILE_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.simpleDeployment",
  poster: LargeDeploymentMobilePoster,
  src: LargeDeploymentMobileVideo,
  tooltips: [
    {
      left: "23.24%",
      id: 0,
      variant: AppVariant.Network,
      description: "gettingStartedWithUniFi.hero.tooltips.network",
      video: LargeDeploymentMobileNetworkVideo,
    },
    {
      id: 1,
      left: "41.75%",
      variant: AppVariant.Protect,
      description: "gettingStartedWithUniFi.hero.tooltips.protect",
      video: LargeDeploymentMobileProtectVideo,
    },
    {
      id: 2,
      left: "60.25%",
      variant: AppVariant.Access,
      description: "gettingStartedWithUniFi.hero.tooltips.access",
      video: LargeDeploymentMobileAccessVideo,
    },
    {
      id: 3,
      left: "78.8%",
      variant: AppVariant.Connect,
      description: "gettingStartedWithUniFi.hero.tooltips.connect",
      video: LargeDeploymentMobileConnectVideo,
    },
  ],
} satisfies IHeroSection;
